export const TOOLTIP_SECTIONS = [
  'Target Property',
  'Data Update',
  'Summary',
];